const MetodologyComponent = ({ show, closeFnc}) => {
    return show === true && <div className="modal">
        <div className="modal-card">
            <div className="close" onClick={closeFnc}>x</div>
            <div className="content">
                <h2>Metodología</h2>
                <p>Esta herramienta permite calcular el monto que deberá pagar si entra en vigor la reforma de ley que transformará el impuesto sobre la renta, en un sistema impositivo global dual.</p>
                <p>La renta global dual agrupa todos los ingresos que el contribuyente tuvo, por cualquier actividad productiva, desarrollada en el territorio nacional y, posteriormente, establece un solo cobro.</p>
                <p>Bajo esa lógica, la calculadora le permitirá integrar sus ingresos de acuerdo con el tipo de contribuyente que usted sea —asalariado y / o trabajador independiente—, y si recibe ingresos por rentas de capital relacionados con su actividad lucrativa.</p>
                <p>Al mismo tiempo, aplicará las deducciones correspondientes, en función de si tiene hijos dependientes o con alguna discapacidad, o bien, si tiene cónyuge, por citar algunos ejemplos.</p>
                <p>Después de que usted respondió todas las preguntas necesarias para sumar los ingresos y restar las deducciones, la herramienta arrojará dos resultados: El monto que usted paga actualmente y el que pagará si entra en vigor la renta global dual.</p>
                <p>Los resultados actuales, son bajo el supuesto de que usted aplica los créditos fiscales anuales por concepto de hijos dependientes (₡18.840 por cada uno) y cónyuge (₡28.440) que actualmente tiene el Ministerio de Hacienda.</p>
                <p>Al tiempo que rebaja del monto a gravar, de ser el caso, el dinero que usted destina a fondos de pensiones complementarias voluntarias.</p>
                <p>Las dos sumas se calcularán de manera mensual y anual.</p>
                <p>Además, se detallará la diferencia entre ambos montos, tanto en términos absolutos como relativos, para que usted pueda dimensionar el impacto de la medida.</p>
                <p>Para hacer los cálculos, se utilizó como base el texto del proyecto de ley 22.393, Ley del Impuesto Sobre la Renta Global Dual, que actualmente se discute en el Congreso y que fue presentado por el gobierno de Carlos Alvarado.</p>
                <p>La herramienta evolucionará conforme a la iniciativa avance en su trámite legislativo, por lo que los cálculos irán variando, en la medida que los diputados introduzcan o quiten variables a la fórmula.</p>
                <h3>Tablas impositivas actuales</h3>
                <p>Para estimar la suma que actualmente pagan los asalariados, se utilizó la siguiente tabla del Ministerio de Hacienda, con base en los ingresos mensuales del contribuyente y tras restar los aportes a fondos de pensión complementaria voluntaria:</p>
                <table>
                    <thead>
                        <tr>
                            <th>Desde</th>
                            <th>Hasta</th>
                            <th>Porcentaje</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>₡0</td>
                            <td>₡842.000</td>
                            <td>0%</td>
                        </tr>
                        <tr>
                            <td>₡842.000</td>
                            <td>₡1.236.000</td>
                            <td>10%</td>
                        </tr>
                        <tr>
                            <td>₡1.236.000</td>
                            <td>₡2.169.000</td>
                            <td>15%</td>
                        </tr>
                        <tr>
                            <td>₡2.169.000</td>
                            <td>₡4.337.000</td>
                            <td>20%</td>
                        </tr>
                        <tr>
                            <td>₡4.337.000</td>
                            <td></td>
                            <td>25%</td>
                        </tr>
                    </tbody>
                </table>
                <p>Una vez obtenido el monto a pagar, se descuentan los créditos fiscales —de ser el caso— se obtiene el resultado final.</p>
                <p>Para estimar la suma que actualmente pagan los trabajadores independientes, se utilizó la siguiente tabla, también del Ministerio de Hacienda, con base en los ingresos anuales, incluyendo aquellos por rentas de capital relacionados con su actividad lucrativa, y tras restar los gastos deducibles y los aportes a fondos de pensión complementaria voluntaria:</p>
                <table>
                    <thead>
                        <tr>
                            <th>Desde</th>
                            <th>Hasta</th>
                            <th>Porcentaje</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>₡0</td>
                            <td>₡3.742.000</td>
                            <td>0%</td>
                        </tr>
                        <tr>
                            <td>₡3.742.000</td>
                            <td>₡5.589.000</td>
                            <td>10%</td>
                        </tr>
                        <tr>
                            <td>₡5.589.000</td>
                            <td>₡9.322.000</td>
                            <td>15%</td>
                        </tr>
                        <tr>
                            <td>₡9.322.000</td>
                            <td>₡18.683.000</td>
                            <td>20%</td>
                        </tr>
                        <tr>
                            <td>₡18.683.000</td>
                            <td></td>
                            <td>25%</td>
                        </tr>
                    </tbody>
                </table>
                <p>En el caso de que el contribuyente sea asalariado e independiente, la exoneración de ₡3.742.000 que tiene como independiente variará según el monto que ya se le rebajó como asalariado, pues no puede gozar de dos exoneraciones.</p>
                <p>Bajo esa lógica si como asalariado ya se le exoneró ₡3.000.000, como independiente solo pagará 0% por los ₡742.000 que le quedan, por encima de esa suma ya comenzará a pagar un 10% y así consecuentemente, según la tabla impositiva antes mencionada.</p>
                <p>En cuanto a la deducción por aporte a un fondo de pensión complementaria voluntaria, en el caso de los contribuyentes que sean asalariados e independientes al mismo tiempo, o bien, que tenga dos salarios, esta se aplicará solo a uno de los dos, al monto más alto que introduzca la persona.</p>
                <p>Esto, bajo el entendido de que esta deducción no puede ser superior al 10% del salario bruto o de los ingresos brutos del trabajador independiente y que, el contribuyente va a querer exonerar el mayor monto posible.</p>
                <h3>Tabla impositiva con renta global dual</h3>
                <p>En el caso de la renta global dual, se suman todos los ingresos que genere el contribuir a lo largo del año, ya sea como asalariado y / o por actividad lucrativa. A ese resultado se le restan los gastos deducibles cuando proceda. Además, se deben deducir los siguientes montos:</p>
                <ul>
                    <li>Si el contribuyente es una persona con discapacidad, se restan ₡ 8.425.000</li>
                    <li>Si tiene hijos dependientes, por cada uno, se restan ₡ 150.000.</li>
                    <li>Si tiene hijos que requieran gastos escolares, por cada uno, se restan ₡ 100.000.</li>
                    <li>Si tiene hijos con discapacidad, por cada uno, se restan ₡ ¢2.106.250.</li>
                    <li>Si tiene cónyuge, se restan ₡ 250.000.</li>
                </ul>
                <p>Al resultado de esa resta, adicionalmente se restan ₡8.425.000, que están exonerados para todos los contribuyentes, y al excedente, se le aplica la siguiente escala impositiva:</p>
                <table>
                    <thead>
                        <tr>
                            <th>Desde</th>
                            <th>Hasta</th>
                            <th>Porcentaje</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>₡0</td>
                            <td>₡5.000.000</td>
                            <td>10%</td>
                        </tr>
                        <tr>
                            <td>₡5.000.000</td>
                            <td>₡12.000.000</td>
                            <td>15%</td>
                        </tr>
                        <tr>
                            <td>₡12.000.000</td>
                            <td>₡19.000.000</td>
                            <td>20%</td>
                        </tr>
                        <tr>
                            <td>₡19.000.000</td>
                            <td>₡29.000.000</td>
                            <td>25%</td>
                        </tr>
                        <tr>
                            <td>₡29.000.000</td>
                            <td></td>
                            <td>27,5%</td>
                        </tr>
                    </tbody>
                </table>
                <p className="credits">EDICIÓN Y ANÁLISIS DE DATOS: NATASHA CAMBRONERO, PERIODISTA: SOFÍA CHINCHILLA, DISEÑO WEB: ESTEBAN ESQUIVEL, PROGRAMACIÓN: JOSUÉ MUÑOZ</p>
            </div>
        </div>
    </div>
};

export default MetodologyComponent;